import { IEdamaMealPayload } from "model/food/types/mealPayload.types"
import getBaseMealPayloadFromFood from "./getBaseMealPayloadFromFood"
import { IEdamaFood, IEdamaMeal } from "model/food/types/edama.types"
import { getImagePayload } from "./getImagePayload"
import { LogMealType } from "model/food/types/base.types"

export const getEdamaMealPayloadFromFood = (
  food: IEdamaFood,
  mealType?: LogMealType,
) => {
  const payload: IEdamaMealPayload = {
    ...getBaseMealPayloadFromFood(food),
    ...getImagePayload(food),
    source: "EDAMAM",
    type: mealType,
    brand: food.brand,
    units: food.units,
  }

  return payload
}
